if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"idun","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(166|269|604|689|82)$/.test(chunkId)},
		rootOutputDir: "../mf/client/",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}